<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="产品名称">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" v-has-permission-code-and="'002000050000'" icon="el-icon-plus"
				@click="toSave()">添加</el-button>
			<el-button type="danger" v-has-permission-code-and="'002000050000'" icon="el-icon-delete"
				@click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="name" width="300" label="产品名称"></el-table-column>
				<el-table-column prop="code" width="120" label="产品编号"></el-table-column>
				<el-table-column prop="po" width="85" label="PO"></el-table-column>
				<el-table-column label="计划时间" width="200">
					<template slot-scope="scope">
						<el-tag type="success">{{ scope.row.startTime }}</el-tag>
						<span>--</span>
						<el-tag type="danger">{{ scope.row.endTime }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="source" width="100" label="产品来源"></el-table-column>
				<el-table-column prop="state" label="状态" width="90"></el-table-column>
				<el-table-column prop="progress" label="进度" width="90">
					<template slot-scope="scope">
						{{ scope.row.progress }}%
					</template>
				</el-table-column>
				<el-table-column prop="sprints" width="70" label="迭代数"></el-table-column>
				<el-table-column prop="allManDay" width="70" label="总人日"></el-table-column>
				<el-table-column prop="allWorkDays" width="150" label="计划周期">
					<template slot-scope="scope">
						<div>
							{{ scope.row.workDays }} / {{ scope.row.allWorkDays }}
							<el-tag v-if="scope.row.workDays == scope.row.allWorkDays"
								style="margin-left: 10px;">截止</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="300px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
							<el-button size="mini" v-has-permission-code-and="'002000050000'"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" type="danger"
								v-has-permission-code-and="'002000050000'"
								@click="remove(scope.$index, scope.row)">删除</el-button>
							<el-button size="mini" type="primary"
								@click="attachManage(scope.$index, scope.row)">附件</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/product/product/product.js';
export default {
	name: 'product',
	components: {
		edit,
	},
	data() {
		return {
			searchParams: {},
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			

		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);

			api.list4Select({}, response => {
				this.productList = response.data;
				this.$caches.products.set(this.productList);

				api.list3(params, response => {
					this.listData = response.data;
					this.listLoading = false;
				})
			})

		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.list()
		},
		attachManage(index, row) {
			//跳转到附件管理页面，并且把产品id传过去，可以直接回显
			this.$router.replace({ path: '/attachment/attachment', query: { productId: row.id, prodNm: row.name } });
		},
	},
	mounted() {
		this.list();

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
